import { browserLocalPersistence, getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import React from "react";
import { RouterProvider } from "react-router-dom";
import {
  AuthProvider,
  FirestoreProvider,
  FunctionsProvider,
  useFirebaseApp,
} from "reactfire";
import "./App.css";
import router from "./router";
import WithFlashProvider from "./utils/FlashProvider";

export default function App() {
  const app = useFirebaseApp();
  const firestoreInstance = getFirestore(app);
  const auth = getAuth(app);
  const functions = getFunctions(app);

  auth.setPersistence(browserLocalPersistence);

  return (
    <FirestoreProvider sdk={firestoreInstance}>
      <AuthProvider sdk={auth}>
        <FunctionsProvider sdk={functions}>
          <WithFlashProvider>
            <RouterProvider router={router} />
          </WithFlashProvider>
        </FunctionsProvider>
      </AuthProvider>
    </FirestoreProvider>
  );
}
